import { render, staticRenderFns } from "./ShowUserTastingFormsList.vue?vue&type=template&id=c77335f4&scoped=true&"
import script from "./ShowUserTastingFormsList.vue?vue&type=script&lang=js&"
export * from "./ShowUserTastingFormsList.vue?vue&type=script&lang=js&"
import style0 from "./ShowUserTastingFormsList.vue?vue&type=style&index=0&id=c77335f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77335f4",
  null
  
)

export default component.exports